/**
 * When to log slow HTTP / API timing as WARN vs INFO. Heavy endpoints (sessions, analytics)
 * legitimately run tens of seconds locally; logging them at 1s floods the console.
 */

/** @param {string} urlOrEndpoint */
export function getSlowFetchWarnThresholdMs(urlOrEndpoint) {
  const u = String(urlOrEndpoint);
  if (u.includes('/v1/matrix/rooms/tags/bulk')) return 12000;
  if (u.includes('/v1/matrix/session')) return 8000;
  if (/\/v1\/resources\/[^/]+\/sessions(\?|$|\/)/.test(u) || u.includes('/sessions/analytics')) {
    return 120000;
  }
  return 8000;
}

/** @param {string} [endpoint] */
export function getApiRequestTimeWarnThresholdMs(endpoint) {
  return getSlowFetchWarnThresholdMs(endpoint || '');
}
